import type { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';
import { ResponseError } from '@backstage/errors';
import type {
  EnvDetailV0,
  EnvDetailV0Wire,
  EnvOverviewV0,
  EnvOverviewV0Wire,
  FeatureFlagMatrixV0Wire,
  IpGatewayInventoryV0Wire,
} from '@internal/plugin-environments-common';
import { parseEnvDetail, parseOverview } from './parse';
import type { EnvironmentsApi } from './types';

export class EnvironmentsClient implements EnvironmentsApi {
  constructor(
    private readonly deps: {
      discoveryApi: DiscoveryApi;
      fetchApi: FetchApi;
    },
  ) {}

  getMatrix(): Promise<FeatureFlagMatrixV0Wire> {
    return this.get('/matrix');
  }

  getIpGateways(): Promise<IpGatewayInventoryV0Wire> {
    return this.get('/ip-gateways');
  }

  async getOverview(): Promise<EnvOverviewV0> {
    return parseOverview(await this.get<EnvOverviewV0Wire>('/overview'));
  }

  async getEnv(name: string): Promise<EnvDetailV0> {
    return parseEnvDetail(
      await this.get<EnvDetailV0Wire>(`/envs/${encodeURIComponent(name)}`),
    );
  }

  private async get<T>(path: string): Promise<T> {
    const baseUrl = await this.deps.discoveryApi.getBaseUrl('environments');
    const res = await this.deps.fetchApi.fetch(`${baseUrl}${path}`);
    if (!res.ok) {
      throw await ResponseError.fromResponse(res);
    }
    return (await res.json()) as T;
  }
}
